import React from 'react';
import { useCRM } from '../context/CRMContext';
import ClientProfile from './ClientProfile';

const GlobalOverlay = ({ userRole, currentUser }) => {
  const { selectedClient, setSelectedClient } = useCRM();

  // If no client is selected, render nothing
  if (!selectedClient) return null;

  return (
    <ClientProfile 
        key={selectedClient.id} 
        client={selectedClient} 
        onClose={() => setSelectedClient(null)} 
        userRole={userRole} 
        currentUser={currentUser}
    />
  );
};

// --- THIS LINE IS CRITICAL ---
export default GlobalOverlay;